module.exports = __webpack_public_path__ + "static/media/WKR1-NEW.5fc58835.apng";